import Sso from './component';
import { SsoButtonProps } from './types';

export default Sso;
export type { SsoButtonProps };
